import React from "react";
import "./Result.css";
import NumberContainer from "../NumberContainer/NumberContainer";

const Result = ({ data }) => {
  return (
    <li className="lottolegenda-result__item line">
      <p className="fw-700 t-21">№{data.number}</p>
      <p className="t-12">Last Draw Date</p>
      <p className="lottolegenda-result__date">{data.date}</p>
      <div className="lottolegenda-latest__part">
        <p className="t-12">Winning Numbers</p>
        <div className="lottolegenda-draws__container">
          {data.winningNumbers.map((i) => (
            <NumberContainer key={i} color={"blue"} number={i} />
          ))}
        </div>
      </div>
      <div className="lottolegenda-latest__part">
        <p className="t-12">Viking Number</p>
        <NumberContainer color={"yellow"} number={data.vikingNumber} />
      </div>
      <div>
        <p className="t-12">Prize Categories</p>
        <ul className="lottolegenda-result__cat-list">
          <li>6 + Viking: {data.cat1}</li>
          <li>6 numbers: {data.cat2}</li>
          <li>5 + Viking: {data.cat3}</li>
          <li>5 numbers: {data.cat4}</li>
          {data.cat5 && <li>4 + Viking: {data.cat5}</li>}
        </ul>
      </div>
    </li>
  );
};

export default Result;
